export default __webpack_public_path__ + "static/media/Rewardsco_Learning.58a3e691.png";